<main class="adherer-page">
  <!-- En-tête de la page -->
  <section class="adherer-hero">
    <div class="container">
      <h1>{{ 'pages.adherer.adherer.text001' | translate }}</h1>
      <p class="subtitle">{{ 'pages.adherer.adherer.text002' | translate }}</p>
    </div>
  </section>

  <!-- Section de présentation et parcours -->
  <section class="adherer-info-section" id="presentation">
    <div class="container">
      <div class="info-card" id="parcours">
        <h2>{{ 'pages.adherer.adherer.text003' | translate }}</h2>
        <p>
          {{ 'pages.adherer.adherer.text004' | translate }}
        </p>
        
        <div class="steps-grid">
        <img
          [src]="parcoursImage()"
          [alt]="
            translateService.language() === 'en'
              ? 'AGBE integration journey'
              : 'Parcours d’intégration à l’AGBE'
          "
          alt="Parcours d’intégration"
          class="integration-image"
        />
        </div>
      </div>
    </div>
  </section>

  <!-- Section Formulaire Intégré HelloAsso -->
  <section class="adherer-form-section" id="formulaire">
    <div class="container">
      <div class="membership-request-card">
        <h2 class="section-title">{{ 'pages.adherer.adherer.requestTitle' | translate }}</h2>
        <p class="section-desc">{{ 'pages.adherer.adherer.requestText' | translate }}</p>
        <form #membershipForm="ngForm" (ngSubmit)="onSubmit(membershipForm)" class="membership-request-form">
          <label>{{ 'pages.adherer.adherer.lastName' | translate }}<input name="nom" [(ngModel)]="formData.nom" required maxlength="120" autocomplete="family-name"></label>
          <label>{{ 'pages.adherer.adherer.firstName' | translate }}<input name="prenom" [(ngModel)]="formData.prenom" required maxlength="120" autocomplete="given-name"></label>
          <label>{{ 'pages.adherer.adherer.email' | translate }}<input type="email" name="email" [(ngModel)]="formData.email" required email maxlength="190" autocomplete="email"></label>
          <label>{{ 'pages.adherer.adherer.phone' | translate }}<input type="tel" name="telephone" [(ngModel)]="formData.telephone" maxlength="40" autocomplete="tel"></label>
          <label>{{ 'pages.adherer.adherer.city' | translate }}<input name="ville" [(ngModel)]="formData.ville" required maxlength="120" autocomplete="address-level2"></label>
          <label>{{ 'pages.adherer.adherer.localChurch' | translate }}<input name="egliseLocale" [(ngModel)]="formData.egliseLocale" maxlength="180"></label>
          <label class="wide">{{ 'pages.adherer.adherer.motivation' | translate }}<textarea name="motivation" [(ngModel)]="formData.motivation" required minlength="10" maxlength="3000" rows="5"></textarea></label>
          @if (success()) { <p class="form-feedback success wide">{{ 'pages.adherer.adherer.success' | translate }}</p> }
          @if (error()) { <p class="form-feedback error wide">{{ error() | translate }}</p> }
          <button class="membership-submit wide" type="submit" [disabled]="membershipForm.invalid || sending()">{{ (sending() ? 'pages.adherer.adherer.sending' : 'pages.adherer.adherer.send') | translate }}</button>
        </form>
      </div>

    </div>
  </section>
</main>
